const apiconfig = {
    develpoment: {
        apiBaseUrl: 'https://dev.padmasaliglobal.com/jaiMp/',
    },
};

export default apiconfig;